"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _FileUploader = require("./FileUploader.styles");

var _strings = _interopRequireDefault(require("../../../constants/strings"));

var _CaptionText = _interopRequireDefault(require("../../TextElements/BasicTextElements/CaptionText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var fileUploaderConstants = _strings.default.fileUploader;
var dragAndDropInstructions = fileUploaderConstants.dragAndDropInstructions,
    browseButton = fileUploaderConstants.browseButton;

var FileUploader = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(FileUploader, _React$PureComponent);

  var _super = _createSuper(FileUploader);

  function FileUploader(props) {
    var _this;

    _classCallCheck(this, FileUploader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleBrowseFile", function (fileArray) {
      _this.props.fileUploadHandler(fileArray);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBrowseClick", function () {
      _this.fileUploader.current.open();
    });

    _this.fileUploader = _react.default.createRef();
    return _this;
  }

  _createClass(FileUploader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          dataTestId = _this$props.dataTestId,
          isDisabled = _this$props.isDisabled,
          requirements = _this$props.requirements;
      return /*#__PURE__*/_react.default.createElement(_FileUploader.FileUploaderWrapper, {
        className: className,
        "data-test-id": dataTestId,
        isDisabled: isDisabled
      }, /*#__PURE__*/_react.default.createElement(_reactDropzone.default, {
        className: "c-file-uploader-drop-zone",
        "data-test-id": "file-uploader-drop-zone",
        onDrop: this.handleBrowseFile,
        ref: this.fileUploader,
        disabled: isDisabled
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-uploader-inner-wrapper"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "c-file-uploader-text",
        "data-test-id": "file-uploader-text"
      }, dragAndDropInstructions), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "c-file-uploader-browse-files",
        "data-test-id": "file-uploader-browse-files"
      }, browseButton)), requirements.length > 0 && /*#__PURE__*/_react.default.createElement(_CaptionText.default, {
        className: "c-file-uploader-caption",
        dataTestId: "file-uploader-caption"
      }, requirements))));
    }
  }]);

  return FileUploader;
}(_react.default.PureComponent);

_defineProperty(FileUploader, "propTypes", {
  /** Class Override */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** disabled flag */
  isDisabled: _propTypes.default.bool,

  /** Exposes the uploaded file */
  fileUploadHandler: _propTypes.default.func.isRequired,

  /** Requirements string to show file restrictions  */
  requirements: _propTypes.default.string
});

_defineProperty(FileUploader, "defaultProps", {
  className: '',
  isDisabled: false,
  requirements: ''
});

var _default = FileUploader;
exports.default = _default;